import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/index-logo.png';
import _imports_1 from '../../assets/qr-code.jpg';
import _imports_2 from '../../assets/contant.png';
import _imports_3 from '../../assets/service.png';
const _withScopeId = n => (_pushScopeId("data-v-dd59a2f6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header_box"
};
const _hoisted_2 = {
  class: "grey_top"
};
const _hoisted_3 = {
  class: "flex_jcsb container"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "city flex_aic"
}, null, -1));
const _hoisted_5 = {
  class: "help flex_aic"
};
const _hoisted_6 = {
  class: "logo_top"
};
const _hoisted_7 = {
  class: "container flex_jcsb flex_aic"
};
const _hoisted_8 = {
  class: "left_nav flex_aic"
};
const _hoisted_9 = {
  key: 0,
  class: "blue_active"
};
const _hoisted_10 = {
  class: "right_search flex_aic"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "135px"
  }
}, null, -1));
const _hoisted_12 = {
  class: "footer_code"
};
const _hoisted_13 = {
  class: "container flex_aic flex_jcsb"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "text_img",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_15 = ["innerHTML"];
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex_aic"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "flex_fdc flex_aic"
}, [/*#__PURE__*/_createElementVNode("p", null, "万象支付宝小程序"), /*#__PURE__*/_createElementVNode("span", null, "扫描二维码进入小程序主页")]), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
})], -1));
const _hoisted_17 = {
  class: "footer_brief"
};
const _hoisted_18 = {
  class: "container"
};
const _hoisted_19 = {
  class: "top_link"
};
const _hoisted_20 = {
  class: "link_text"
};
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"link_img\" data-v-dd59a2f6><div class=\"flex_aic flex_jcsb\" data-v-dd59a2f6><a href=\"https://cschat.antcloud.com.cn/index.htm?tntInstId=BiB_Rw5m&amp;scene=SCE01202417\" class=\"flex_aic\" data-v-dd59a2f6><img src=\"" + _imports_2 + "\" alt=\"\" data-v-dd59a2f6><span data-v-dd59a2f6>在线客服</span></a><div class=\"flex_aic flex_fdc\" data-v-dd59a2f6><p data-v-dd59a2f6>周一至周日</p><p data-v-dd59a2f6>9:00-18:00</p></div></div><p data-v-dd59a2f6>公司地址：深圳市南山区沙河街道高发社区侨香路4086号 智慧广场B栋402A1</p><p data-v-dd59a2f6>4008091388</p></div>", 1);
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bom_intro"
}, [/*#__PURE__*/_createElementVNode("p", null, "地址：深圳市南山区沙河街道高发社区侨香路4086号 智慧广场B栋402A1"), /*#__PURE__*/_createElementVNode("p", null, "© 深圳市趣易租网络科技有限公司 版权所有"), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("a", {
  style: {
    "color": "#fff"
  },
  href: "https://beian.miit.gov.cn/"
}, "粤ICP备2021129882号-1")])], -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://cschat.antcloud.com.cn/index.htm?tntInstId=BiB_Rw5m&scene=SCE01202417",
  class: "service"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
})], -1));
import { ref, reactive, computed } from 'vue';
import { useStore } from 'vuex';
import { selectCateProduct } from '@/api/api';
import { useRouter } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  setup(__props) {
    const store = useStore();
    const router = useRouter();
    store.dispatch('getHeaderList'); // 获取顶部导航
    store.dispatch('getPhoneNumber'); // 获取手机号码
    let navList = computed(() => {
      return store.state.navHeaderList;
    });
    let phoneList = computed(() => {
      return store.state.phoneNumberList;
    });
    let helpList = computed(() => {
      return store.state.articleCateList;
    });
    let navAd = computed(() => {
      return store.state.navAd;
    });
    let hotCodeShow = ref(false);
    let resultList = reactive({
      list: []
    });
    let searchCode = ref('');
    let goCategory = () => {
      router.push({
        path: '/category',
        query: {
          code: searchCode.value
        }
      });
    };
    let onFocusout = () => {
      setTimeout(() => {
        hotCodeShow.value = false;
      }, 310);
    };
    let timer;
    // 防抖
    let onInput = () => {
      timer && clearTimeout(timer);
      timer = setTimeout(async () => {
        let {
          data
        } = await selectCateProduct({
          tag: 'specialty',
          categoryid: '',
          typeid: '',
          page: '',
          pagenum: '',
          sortby: '',
          city: '',
          ds: 4,
          search_name: searchCode.value
        });
        if (data.resultTag == 'y') {
          resultList.list = data.productlist.page_result.slice(0, 7);
          hotCodeShow.value = true;
        }
      }, 500);
    };
    return (_ctx, _cache) => {
      const _component_el_link = _resolveComponent("el-link");
      const _component_router_link = _resolveComponent("router-link");
      const _component_Search = _resolveComponent("Search");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_link, {
        href: "",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).push('/help-center')),
        underline: false
      }, {
        default: _withCtx(() => [_createTextVNode("帮助中心")]),
        _: 1
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(phoneList), (item, index) => {
        return _openBlock(), _createBlock(_component_el_link, {
          href: "",
          underline: false,
          key: index
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.article_title), 1)]),
          _: 2
        }, 1024);
      }), 128))])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
        src: _imports_0,
        alt: "",
        onClick: _cache[1] || (_cache[1] = $event => _unref(router).push('/'))
      }), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navList), (item, index) => {
        return _openBlock(), _createBlock(_component_router_link, {
          class: "nav_cate",
          key: index,
          to: {
            name: 'Category',
            query: {
              id: item.link,
              brandId: ''
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name) + " ", 1), item.sub_title ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(item.sub_title), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1032, ["to"]);
      }), 128))])]), _createElementVNode("div", _hoisted_10, [_withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "请输入查询机型",
        href: "javascript:;",
        onInput: _cache[2] || (_cache[2] =
        //@ts-ignore
        (...args) => _unref(onInput) && _unref(onInput)(...args)),
        onFocusout: _cache[3] || (_cache[3] =
        //@ts-ignore
        (...args) => _unref(onFocusout) && _unref(onFocusout)(...args)),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(searchCode) ? searchCode.value = $event : searchCode = $event)
      }, null, 544), [[_vModelText, _unref(searchCode)]]), _createElementVNode("a", {
        href: "javascript:;",
        onClick: _cache[5] || (_cache[5] =
        //@ts-ignore
        (...args) => _unref(goCategory) && _unref(goCategory)(...args))
      }, [_createVNode(_component_el_icon, {
        size: 24,
        color: "#FFFFFF"
      }, {
        default: _withCtx(() => [_createVNode(_component_Search)]),
        _: 1
      })]), _withDirectives(_createElementVNode("div", {
        onClick: _cache[6] || (_cache[6] =
        //@ts-ignore
        (...args) => _unref(goCategory) && _unref(goCategory)(...args))
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resultList).list, (item, index) => {
        return _openBlock(), _createElementBlock("a", {
          href: "javascript:;",
          key: index
        }, _toDisplayString(item.product_name), 1);
      }), 128))], 512), [[_vShow, _unref(hotCodeShow)]])])])])]), _hoisted_11, _createVNode(_component_router_view), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", {
        innerHTML: _unref(navAd)
      }, null, 8, _hoisted_15), _hoisted_16])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(helpList), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [_createElementVNode("p", null, _toDisplayString(item.category_name), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.articleList, (tag, okey) => {
          return _openBlock(), _createBlock(_component_router_link, {
            key: okey,
            to: {
              name: 'helpCenter',
              query: {
                id: tag.id
              }
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(tag.article_title), 1)]),
            _: 2
          }, 1032, ["to"]);
        }), 128))]);
      }), 128))]), _hoisted_21]), _hoisted_22])]), _hoisted_23], 64);
    };
  }
});